const SvgIcon = ({size = '48', isChecked = true, color='#000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 48 48"
  >
    <path stroke={color} strokeOpacity="0.7" d="M6.5 5.5h36v36h-36z"></path>
    {isChecked &&
      <path
        fill={color}
        d="M19.1 36 7.7 24.6l2.85-2.85 8.55 8.55 18.35-18.35 2.85 2.85z"
      ></path>
    }
  </svg>
);

export default SvgIcon;
